import {useState} from 'react'
import {useWorkoutsContext} from "../hooks/useWorkoutsContext"
import {useAuthContext} from "../hooks/useAuthContext"
import axios from 'axios'

const WorkoutForm =()=> {
const {dispatch}=useWorkoutsContext()
const [title,setTitle]=useState('')
const [brand,setBrand]=useState('')
const [price,setPrice]=useState('')
const [error,setError]= useState('')
const [imageName,setImageName] = useState('')
const [file, setFile] = useState()
const [emptyFields, setEmptyFields] =useState([])
const {user} = useAuthContext()

const upload = async(e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append("image", file)
    const result = await axios.post('https://webservicetry1.onrender.com/api/images', formData, { headers: {'Content-Type': 'multipart/form-data'}}).then(res=> {setImageName(res.data)})
    }

const handleSubmit= async (e) => {
    e.preventDefault()

    if(!imageName){
        setError('select image first of product and click upload first')
        return
    }
   
    if (!user) {
        setError('you must be logged in')
        return
    }

    const workout = {title,brand, price,imageName}
    const response= await fetch('https://webservicetry1.onrender.com/api/products',{
        method:'POST',
        body: JSON.stringify(workout),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
    }})

const json= await response.json()

if (!response.ok){setError(json.error)}

    if (response.ok){
        setTitle('')
        setBrand('')
        setPrice('')
        setError(null)
        console.log('new workout added',json)
        dispatch({type:'CREATE_WORKOUT',payload:json})
    }
}
return (
<form className="create" onSubmit={handleSubmit}>
<h3>add a product</h3>
<label>Product Name</label>
<input
type="text"
onChange={(e)=> setTitle(e.target.value)}
value={title}
className={emptyFields.includes('title')? 'error': ''}
/>

<label>product type</label>
<input
type="text"
onChange={(e)=> setBrand(e.target.value)}
value={brand}
className={emptyFields.includes('title')? 'error': ''}
/>

<label>Price</label>
<input
type="number"
onChange={(e)=> setPrice(e.target.value)}
value={price}
className={emptyFields.includes('title')? 'error': ''}
/>

<label>Product Picture</label>
<input
filename={file} 
onChange={e => setFile(e.target.files[0])} 
type="file" 
accept="image/*"
></input>

<button1 onClick={upload}>upload</button1>

<button>Add a product</button>

{error && <div className="error">{error}</div>}
</form>)


}

export default WorkoutForm